import type { WorkItemDto } from '@customTypes/types';

import { SendWorkInviteView } from './SendWorkInviteView';
import { useSendInviteView } from './useSendInviteView';

export const SendWorkInviteContaiener = ({
  clubId,
  artistId,
  workItem
}: {
  clubId: string;
  artistId: string;
  workItem: WorkItemDto | null;
}) => {
  const {
    state: { canSendInvite, cause },
    functions: { revokeInvite }
  } = useSendInviteView({ clubId, workItem, artistId });

  return (
    <SendWorkInviteView
      artistId={artistId}
      canSendInvite={canSendInvite}
      cause={cause}
      clubId={clubId}
      revokeInvite={revokeInvite}
    />
  );
};
